/**
 * @generated SignedSource<<0d2f2df44e9bf2c541aa094c4f580bbb>>
 * @relayHash 47c949c21db5d28c8b91b5a6492b2d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 133c76ca542b5dff635ac12c76a67cc79992d30e6af1fb0d35e9d337342113ba

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentRestrictionStateInput = "EDIT_RESTRICTED" | "OPEN" | "VIEW_RESTRICTED" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type PageRestrictionsInput = {
  includeInvites?: boolean | null;
  read?: PageRestrictionInput | null;
  update?: PageRestrictionInput | null;
};
export type PageRestrictionInput = {
  group?: ReadonlyArray<PageGroupRestrictionInput> | null;
  user?: ReadonlyArray<PageUserRestrictionInput> | null;
};
export type PageGroupRestrictionInput = {
  id?: string | null;
  name: string;
};
export type PageUserRestrictionInput = {
  id: string;
};
export type ConfluenceContentPermissionsInput = {
  edit?: ReadonlyArray<ConfluenceContentPermissionPrincipalInput | null> | null;
  view?: ReadonlyArray<ConfluenceContentPermissionPrincipalInput | null> | null;
};
export type ConfluenceContentPermissionPrincipalInput = {
  id: string;
  type: ConfluencePrincipalType;
};
export type useConvertPageToBlogMutation$variables = {
  cloudId: string;
  content?: string | null;
  contentId: string;
  destinationSpaceKey: string;
  message?: string | null;
  ncsStepVersion?: string | null;
  permissions?: ConfluenceContentPermissionsInput | null;
  restrictionState?: ConfluenceContentRestrictionStateInput | null;
  restrictions?: PageRestrictionsInput | null;
  schedulePublishDate?: string | null;
  sourceStatus: string;
  suppressNotifyWatchers?: boolean | null;
  syncRev?: string | null;
  title?: string | null;
  version?: number | null;
};
export type useConvertPageToBlogMutation$data = {
  readonly confluence_convertToBlogpost: {
    readonly content: {
      readonly id: string | null;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      } | null;
      readonly status: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useConvertPageToBlogMutation = {
  response: useConvertPageToBlogMutation$data;
  variables: useConvertPageToBlogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationSpaceKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ncsStepVersion"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictionState"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictions"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schedulePublishDate"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceStatus"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suppressNotifyWatchers"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "syncRev"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v15 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentBody",
            "variableName": "content"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "minorEdit",
            "variableName": "suppressNotifyWatchers"
          },
          {
            "kind": "Variable",
            "name": "ncsStepVersion",
            "variableName": "ncsStepVersion"
          },
          {
            "kind": "Variable",
            "name": "permissions",
            "variableName": "permissions"
          },
          {
            "kind": "Variable",
            "name": "restrictionState",
            "variableName": "restrictionState"
          },
          {
            "kind": "Variable",
            "name": "restrictions",
            "variableName": "restrictions"
          },
          {
            "kind": "Variable",
            "name": "schedulePublishDate",
            "variableName": "schedulePublishDate"
          },
          {
            "kind": "Variable",
            "name": "syncRev",
            "variableName": "syncRev"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
          },
          {
            "kind": "Variable",
            "name": "versionMessage",
            "variableName": "message"
          }
        ],
        "kind": "ObjectValue",
        "name": "confluenceContentInput"
      },
      {
        "kind": "Variable",
        "name": "destinationSpaceKey",
        "variableName": "destinationSpaceKey"
      },
      {
        "kind": "Variable",
        "name": "sourceStatus",
        "variableName": "sourceStatus"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "success"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    },
    (v17/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        },
        {
          "kind": "ScalarField",
          "name": "editui"
        }
      ]
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "message"
},
v20 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useConvertPageToBlogMutation",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "ConfluenceConvertContentToBlogpostPayload",
        "kind": "LinkedField",
        "name": "confluence_convertToBlogpost",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v18/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v20/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v5/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Operation",
    "name": "useConvertPageToBlogMutation",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "ConfluenceConvertContentToBlogpostPayload",
        "kind": "LinkedField",
        "name": "confluence_convertToBlogpost",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v18/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v20/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "47c949c21db5d28c8b91b5a6492b2d11",
    "id": "133c76ca542b5dff635ac12c76a67cc79992d30e6af1fb0d35e9d337342113ba",
    "metadata": {},
    "name": "useConvertPageToBlogMutation",
    "operationKind": "mutation",
    "text": "mutation useConvertPageToBlogMutation($contentId:ID!,$content:String,$message:String,$suppressNotifyWatchers:Boolean,$syncRev:String,$ncsStepVersion:String,$title:String,$version:Int,$schedulePublishDate:String,$restrictions:PageRestrictionsInput,$permissions:ConfluenceContentPermissionsInput,$restrictionState:ConfluenceContentRestrictionStateInput,$cloudId:ID!,$destinationSpaceKey:String!,$sourceStatus:String!){confluence_convertToBlogpost(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,syncRev:$syncRev,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,restrictionState:$restrictionState,permissions:$permissions,schedulePublishDate:$schedulePublishDate,title:$title,version:$version,versionMessage:$message},destinationSpaceKey:$destinationSpaceKey,sourceStatus:$sourceStatus}){success,content{status,id,links{webui,editui}},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "0df7bc0648fed90fface6ce0c455deca";

export default node;
